var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-4 font-weight-bold",attrs:{"outlined":""}},[_c('v-card-title',{staticClass:"font-weight-bold"},[_vm._v("Impact / Spend")]),_c('HorizontalBar',{attrs:{"chartData":_vm.chartData,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }